import {geometryTypes} from '../config/GeometryTypes'
import {PolyEdgeController} from './PolyEdgeController'
import {createGeometryByRepresentationType} from '../factories/GeometryFactory'
import { vector3ToVector2 } from '../helper/GeometryHelper'

export class PolylineController extends PolyEdgeController {

    onLeftMouseDown(event, geometry, currentGeometries) {
        if (!geometry) {
          console.log("New Axis")
            return this.onLeftMouseDownNew(event, currentGeometries)
        } else {
          console.log("Edit axis")
            return this.onLeftMouseDownEdit(event, geometry, currentGeometries)
        }
    }

    onLeftMouseDownNew(event, currentGeometries) {
      console.log("rep Polyline:"+this.representationType)
        const polyline = createGeometryByRepresentationType(this.representationType, this.group)
        return super.onLeftMouseDownNew(event, polyline, currentGeometries)
    }

    onLeftMouseDownEdit(event, polyline, currentGeometries) {
        if (!polyline)
            return false

        switch (polyline.getAction()) {
            case polyline.actions.addVertex:
                if (currentGeometries.length !== 1)
                    return false

                let isOK =true
                let position=this.getCurrentPosition(event, polyline.getLastVertex().position)
                console.log("addVertex")
                console.log(position)
                console.log(polyline)


                let nVerts=polyline.getVertices().length
                if(nVerts>1){
                  console.log("nverts: "+nVerts)
                  let vert=polyline.getVertices()[nVerts-2]
                  console.log("vert")
                  console.log(vert.position)
                  let vertPosition=vector3ToVector2(vert.position)
                  if (vertPosition.distanceTo(position)<0.01){
                    isOK=false
                  }
                  //let distance=position
                }
                if(isOK){
                  polyline.addVertex(position)
                  return true
                }else{
                  return false
                }
            case polyline.actions.select:
                const raycastHitObject = this.floorPlanerController.getRaycastHitObjectForGeometryByGeometryTypes(polyline,
                    [geometryTypes.vertex, geometryTypes.edge])

                if (!raycastHitObject)
                    return false

                switch (raycastHitObject.geometryType) {
                    case geometryTypes.vertex:
                        polyline.setDraggedVertex(raycastHitObject)
                        polyline.setAction(polyline.actions.dragVertex)
                        return true
                    case geometryTypes.edge:
                      if (event.altKey){
                        polyline.addVertexToEdge(raycastHitObject, this.floorPlanerController.getCurrentPosition())
                        polyline.setAction(polyline.actions.dragVertex)
                        return true
                      }

                    default:
                        return false
                }
            default:
                return false
        }
    }

    onLeftMouseDoubleClick(event, polygon, currentGeometries) {
        return super.onLeftMouseDoubleClick(event, polygon, currentGeometries, 2)
    }

    onEnterDown(event, polyline, currentGeometries) {
        return super.onEnterDown(event, polyline, currentGeometries, 2)
    }

}